export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const resultPerPage = 10;
export const key = '658d0530-db41-45d0-8568-6a0998eb16ce';
